import DataTable, {
	TableBody,
	TableColumn,
	TableHeader,
	TableRow,
} from 'react-md/lib/DataTables'
import { TableContainer } from 'ui/StyledComponents/Tables'
import { accountTransactionsHeaders } from './accountTransactionsHeaders'
import { useIntl } from 'react-intl'
import type { AccountTransaction } from '@viilu-web/shared/types/account-transactions'
import AccountTransactionsTableRow from './AccountTransactionsTableRow'
import Pagination from '../../components/Pagination'
import { useState } from 'react'

type AccountTransactionsTableProps = {
	transactions: AccountTransaction[]
	totalItemCount: number
	itemsPerPage: number
}

function AccountTransactionsTable(props: AccountTransactionsTableProps) {
	const { transactions, totalItemCount, itemsPerPage } = props

	const [paginationPage, setPaginationPage] = useState(0)

	const intl = useIntl()

	const handlePaginationBack = () => {
		if (paginationPage === 0) {
			return
		}
		setPaginationPage((prevPage) => prevPage - 1)
	}

	const handlePaginationNext = () => {
		if (paginationPage === Math.ceil(totalItemCount / itemsPerPage) - 1) {
			return
		}
		setPaginationPage((prevPage) => prevPage + 1)
	}

	const renderTableHeaders = () => {
		return (
			<TableRow>
				{accountTransactionsHeaders.map((header) => (
					<TableColumn key={header.key}>{header.title(intl)}</TableColumn>
				))}
			</TableRow>
		)
	}

	const renderTableRows = () => {
		return transactions
			.map((transaction) => (
				<AccountTransactionsTableRow
					key={transaction.transactionId}
					transaction={transaction}
				/>
			))
			.concat(
				<tr
					key="empty-row"
					className="full-width"
					style={{ height: 100, background: 'white' }}
				></tr>,
			)
	}

	return (
		<TableContainer>
			<DataTable
				plain
				style={{ background: 'white', maxHeight: 'calc(100vh - 205px)' }}
			>
				<TableHeader
					style={{
						position: 'sticky',
						top: 0,
						zIndex: 1,
						background: 'white',
					}}
				>
					{renderTableHeaders()}
				</TableHeader>
				<TableBody>{renderTableRows()}</TableBody>
			</DataTable>
			<Pagination
				rowCount={totalItemCount}
				pageIndex={paginationPage + 1}
				rowsPerPage={itemsPerPage}
				onBack={handlePaginationBack}
				onNext={handlePaginationNext}
			/>
		</TableContainer>
	)
}

export default AccountTransactionsTable
